import React, { useEffect } from "react";

const Notification = ({ message, type, onDismiss }) => {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(onDismiss, 3000);
    return () => clearTimeout(timer);
  }, [message, onDismiss]);

  if (!message) return null;

  const baseClasses =
    "fixed top-5 right-5 px-4 py-3 rounded-md shadow-lg text-white text-sm animate-fade-in-down";
  const typeClasses = type === "success" ? "bg-green-500" : "bg-red-500";

  return <div className={`${baseClasses} ${typeClasses}`}>{message}</div>;
};

export default Notification;
